import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[tablaTemplate]',
  host: {},
})
export class TablaTemplateDirective {
  @Input() type?: string;

  @Input('tablaTemplate') name?: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name ? this.name : "";
  }
}
